export default "__VITE_ASSET__72da508d__"